import React, { useState } from "react";
import { Breadcrumb, Col, Form, Row, Card } from "react-bootstrap";
import SecBTN from "../../UI/SecBTN";
import Graybg from "../../UI/Graybg";
import userService from "../../app/services/user.service";

const BulkPaperRequest = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [paperData, setPaperData] = useState(null);

  const downloadFile = () => {
    fetch(window.location.origin + "/files/jeemains.xlsx").then(
      (response) => {
        response.blob().then((blob) => {
          const fileURL = window.URL.createObjectURL(blob);
          const alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "jeemains.xlsx";
          alink.click();
        });
      }
    );
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const HandlePaperUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    userService
      .bulkpaperUpload(formData)
      .then((res) => {
        console.log("API success", res);

        // Adjust according to your API response structure
        setPaperData(res);
        console.log(res.paper)

        alert("File uploaded successfully!");
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to upload the file.");
      });
  };

  return (
    <div className="section">
      <h4>Bulk Paper Request</h4>

      <Breadcrumb>
        <Breadcrumb.Item active>Bulk Paper Request</Breadcrumb.Item>
      </Breadcrumb>

      <Graybg>
        <Row>
          <Col lg={6} md={6} sm={12} className="mb-3">
            <h5 className="mb-3">Upload Paper Request</h5>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload here:</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>

            <SecBTN className="sec-btn1" onClick={HandlePaperUpload}>
              Upload
            </SecBTN>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <SecBTN className="sec-btn1" onClick={downloadFile}>
              <i className="fa fa-download"></i> Sample File
            </SecBTN>
          </Col>
        </Row>

        {/* Response Card */}
        {paperData && (
          <Card className="mt-4 shadow-sm">
            <Card.Body>
              <h5>Uploaded Paper Details</h5>

              <p>
                <strong>Paper ID:</strong> {paperData.paper}
              </p>

              <p>
                <strong>Paper Name:</strong> {paperData.rowsAfterFirst[0][5]}
              </p>
            </Card.Body>
          </Card>
        )}
      </Graybg>
    </div>
  );
};

export default BulkPaperRequest;